module.exports = __webpack_public_path__ + "media/images/emoticons/leftright-76b9f3f0f600c8fdb59d11b5f3ed0a43.gif";